import { render, staticRenderFns } from "./ModalSuporteGrupoEquipamento.vue?vue&type=template&id=1c3e4a55&scoped=true"
import script from "./ModalSuporteGrupoEquipamento.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteGrupoEquipamento.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteGrupoEquipamento.vue?vue&type=style&index=0&id=1c3e4a55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3e4a55",
  null
  
)

export default component.exports